'use strict';

const { localStorage, sessionStorage } = require('dibs-browser-storage');

const tourActions = {
    increaseStep(actionContext, payload, done) {
        const { type } = payload;
        actionContext.dispatch('tour:step:increase', type);
        done();
    },

    openTour(actionContext, payload, done) {
        const { type } = payload;
        actionContext.dispatch('tour:open', type);
        done();
    },

    closeTour(actionContext, payload, done) {
        const { type } = payload;
        actionContext.dispatch('tour:close', type);
        done();
    },

    setSession(actionContext, payload, done) {
        const { type } = payload;
        sessionStorage.setItem(type, true);
        done();
    },

    increaseSession(actionContext, payload, done) {
        const { type } = payload;
        const storage = localStorage.getItem(type) || 0;
        localStorage.setItem(type, storage + 1);
        done();
    },
};

module.exports = tourActions;



// WEBPACK FOOTER //
// ./assets/js/components/Tour/tourActions.es.js